import Logo from "./../../Assets/Imgs/Main_Logo.png"

const CellImg = ({src,onClick}) => {

  return(
    <img 
      onClick={onClick}
      src= {src ?  src : Logo}
      alt={src}
      loading="lazy"
      style={{
        cursor:"pointer",
        padding:"8px",
        width: '100px',
        height: '80px',
        objectFit: "contain",
        borderRadius: '10px',
        scale:"initial"
      }}
    />
  )
}

export default CellImg